module.exports = __webpack_public_path__ + "img/admin.d36f02a7.png";